import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=657a80cc&scoped=true&"
var script = {}
import style0 from "./submit.vue?vue&type=style&index=0&id=657a80cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a80cc",
  null
  
)

export default component.exports